import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '../../UI';
export var profileGet = function profileGet(profileId) {
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'profile']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH, "/profile/").concat(profileId, "?_format=json"), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(profileGetLoaded(profileId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var profileUpdate = function profileUpdate(profileId, values) {
  var API_URL = config.get('API_URL');
  var csrfToken;
  return function (dispatch) {
    dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_REQUEST));
    fetch("".concat(API_URL, "/session/token"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/profile/").concat(profileId), {
        method: 'PATCH',
        credentials: 'include',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function (response) {
        dispatch(profileGetLoaded(profileId, response));
        dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var PROFILE_GET_LOADED = 'PROFILE_GET_LOADED';
export function profileGetLoaded(profileId, data) {
  return {
    type: PROFILE_GET_LOADED,
    profile_id: profileId,
    data: data
  };
}
export var PROFILE_UNLOAD = 'PROFILE_UNLOAD';
export function profileUnload() {
  return {
    type: PROFILE_UNLOAD
  };
}